import styled, { css } from 'styled-components';
//@ts-ignore
import { tokens } from '@mindtickle/styles/lib';
//@ts-ignore
import EntityOverviewCard from '@mindtickle/entity-overview-card';
//@ts-ignore
import { ButtonSkeleton, InlineSkeleton } from '@mindtickle/skeleton';

const commonStyles = css`
  height: 24px;
  border-radius: 4px;
`;

const StyledEntityOverviewCard = styled(EntityOverviewCard)`
  && {
    height: 59px;
    background: ${tokens.bgTokens.COLOR_BG_DEFAULT};
    box-shadow: 0 0px 2px ${tokens.bgTokens.COLOR_BG_DISABLED};
    width: 100%;
    position: fixed;
    z-index: 20;
    border-radius: 0;
    .top-wrp {
      height: inherit;
      padding: 0 15px;

      .left-top {
        height: inherit;
        display: flex;
        align-items: center;
      }
      .right-top {
        height: inherit;
        align-items: center;
      }
    }
  }
`;
const StyledButtonSkeleton = styled(ButtonSkeleton)`
  &&&& {
    height: 24px;
    width: 24px;
    border-radius: 4px;
    margin-right: 14px;
  }
`;

const StyledLogoSkeleton = styled(InlineSkeleton)`
  && {
    ${commonStyles};
  }
`;
const StyledSearchSkeleton = styled(InlineSkeleton)`
  && {
    margin-left: 24px;
    ${commonStyles};
  }
`;
const StyledReportButtonSkeleton = styled(InlineSkeleton)`
  && {
    margin-right: 14px;
    ${commonStyles};
  }
`;
const LOGO_SKELETON_STYLES = { width: '150px', height: '24px' };
const SEARCH_SKELETON_STYLES = { width: '200px', height: '24px' };
const REPORT_BUTTON_SKELETON_STYLES = { width: '170px', height: '24px' };
const BUTTON_SKELETON_STYLES = { width: '24px' };

const SkeletonButtonLoaderList = () => {
  let list = [];
  for (let i = 0; i < 4; i++) {
    list.push(<StyledButtonSkeleton style={BUTTON_SKELETON_STYLES} key={i} active />);
  }
  return <>{list}</>;
};

const SkeletonLoader = () => (
  <>
    <StyledEntityOverviewCard
      leftTop={
        <>
          <StyledLogoSkeleton style={LOGO_SKELETON_STYLES} />
          <StyledSearchSkeleton style={SEARCH_SKELETON_STYLES} />
        </>
      }
      rightTop={
        <>
          <StyledReportButtonSkeleton style={REPORT_BUTTON_SKELETON_STYLES} />
          <SkeletonButtonLoaderList />
        </>
      }
    />
  </>
);
export default SkeletonLoader;
